/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxCrossedAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M0 2.4A2.4 2.4 0 0 1 2.4 0h19.2A2.4 2.4 0 0 1 24 2.4v19.2a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 21.6zm2.4-1.2c-.107 0-.212.014-.31.04L12 11.153l9.91-9.911a1.166 1.166 0 0 0-.31-.041zm-1.16.89c-.026.098-.04.202-.04.31v19.2c0 .107.014.212.04.31L11.153 12zm.85 20.67c.098.026.203.04.31.04h19.2c.107 0 .212-.014.31-.04L12 12.847zm20.67-.85c.026-.098.04-.203.04-.31V2.4c0-.107-.014-.212-.04-.31L12.847 12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCheckboxCrossedAlt as CheckboxCrossedAlt };
